<template>
  <el-input
    :value="value"
    :placeholder="$attrs.placeholder || defPlaceholder"
    v-bind="$attrs"
    class="rc-input"
    :size="size"
    :clearable="clearable"
    v-on="$listeners"
    @input="inputHandler"
    @keyup.enter.native="handleClick"
  >
    <slot>
      <i
        slot="suffix"
        :class="`el-input__icon ${$attrs.class || 'el-icon-search'}`"
        @click="handleClick"
      />
    </slot>
  </el-input>
</template>

<script>
export default {
  name: "RcSearch",
  props: {
    value: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
    item: {
      type: Object
    },
    size: {
      type: String,
      default: "small"
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defPlaceholder: this.$t("common.search")
    };
  },
  methods: {
    handleClick() {
      this.$emit("click", this.value, this.$attrs);
    },
    inputHandler(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-input {
  .el-input__icon {
    cursor: pointer;
  }
}
</style>
